import { useSelector } from 'react-redux'

import { selectStripePaymentMethods } from 'root-redux/selects/common'

import { useExperimentalFeatures } from 'hooks/useExperimentalFeatures'

import { PaymentMethod } from 'modules/purchase/constants'

export const useIsUpiAvailable = (): boolean => {
  const stripePaymentMethods = useSelector(selectStripePaymentMethods)
  const { isAyah116ParentingUpiTest } = useExperimentalFeatures()

  return (
    isAyah116ParentingUpiTest &&
    stripePaymentMethods.includes(PaymentMethod.UPI)
  )
}
